import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { LandingV2 } from './pages/LandingV2';
import { LandingV3 } from './pages/LandingV3';
import { LandingV4 } from './pages/LandingV4';
import { LandingV5 } from './pages/LandingV5';
import { LandingV6 } from './pages/LandingV6';
import { LandingVInt } from './pages/LandingVInt';
import { LandingInt02 } from './pages/LandingInt02';
import { LandingUS } from './pages/LandingUS';
import { LandingUK } from './pages/LandingUK';
import { LandingV1 } from './pages/LandingV1';
import { LandingTest } from './pages/LandingTest';
export const AppRouter = () => {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/us" element={<LandingUS data-id="element-4" />} data-id="element-3" />
        <Route path="/uk" element={<LandingUK data-id="element-6" />} data-id="element-5" />
        <Route path="/vint" element={<LandingVInt data-id="element-8" />} data-id="element-7" />
        <Route path="/vint02" element={<LandingInt02 data-id="element-10" />} data-id="element-9" />
        <Route path="/test" element={<LandingTest data-id="element-12" />} data-id="element-11" />
        <Route path="/v1" element={<LandingV1 data-id="element-14" />} data-id="element-13" />
        <Route path="/v2" element={<LandingV2 data-id="element-16" />} data-id="element-15" />
        <Route path="/v3" element={<LandingV3 data-id="element-18" />} data-id="element-17" />
        <Route path="/v4" element={<LandingV4 data-id="element-20" />} data-id="element-19" />
        <Route path="/v5" element={<LandingV5 data-id="element-22" />} data-id="element-21" />
        <Route path="/v6" element={<LandingV6 data-id="element-24" />} data-id="element-23" />
        <Route path="/*" element={<App data-id="element-26" />} data-id="element-25" />
      </Routes>
    </BrowserRouter>;
};